import { render, staticRenderFns } from "./CompletionByPos.vue?vue&type=template&id=4a449082&scoped=true&"
import script from "./CompletionByPos.vue?vue&type=script&lang=js&"
export * from "./CompletionByPos.vue?vue&type=script&lang=js&"
import style0 from "./CompletionByPos.vue?vue&type=style&index=0&id=4a449082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a449082",
  null
  
)

/* custom blocks */
import block0 from "./CompletionByPos.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
